import { AcornApi } from './acorn-script.types';
import useCdnScript from '../useCdnScript';


const ACORN_WIDGET_SCRIPT_ID: string = 'acorn-script';

const isAcornApiAvailable = (): boolean => window.acornStandardParameters !== undefined
  && window.setAcornStandardParameters !== undefined
  && window.getAcornQrCodeUrl !== undefined;

const parseAcornApi = (): AcornApi | null => {
  if (window.acornStandardParameters
    && window.setAcornStandardParameters
    && window.getAcornQrCodeUrl) {
    return {
      acornStandardParameters: window.acornStandardParameters,
      setAcornStandardParameters: window.setAcornStandardParameters,
      getAcornQrCodeUrl: window.getAcornQrCodeUrl,
    };
  }

  return null;
};

export const useAcornCdnScript = (scriptCdnUrl: string | undefined): AcornApi | null => {
  return useCdnScript<AcornApi>({
    isTypeModule: true,
    scriptId: ACORN_WIDGET_SCRIPT_ID,
    scriptSrc: scriptCdnUrl,
    isScriptApiAvailable: isAcornApiAvailable,
    parseScriptApi: parseAcornApi,
  });
};